import firebase from "../firebase";

export default function({ officeId, senderId, userId, conversationId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "addParticipantToConversation",
        data: { officeId, senderId, userId, conversationId }
    });
}
